import {Show} from 'platform/foundation';

import {
  COLUMN_SEPARATOR_STYLE,
  PINNED_INDICATOR_STYLE,
  PINNED_LEFT_BOUNDARY_LINE_STYLE,
  PINNED_LEFT_EDGE_LINE_STYLE,
  PINNED_RIGHT_EDGE_LINE_STYLE,
  RESIZE_INDICATOR_LEFT_STYLE,
  RESIZE_INDICATOR_STYLE,
} from '../../../../../../constants/borderStyles';

type HeaderCellDecoratorsProps = {
  isPinned: boolean;
  isPinnedLeft: boolean;
  isRightPinned: boolean;
  /** True on the LAST left-pinned column — its right edge renders the elevation
   * boundary shade instead of the plain separator line. */
  isLastPinnedLeft: boolean;
  isBeingResized: boolean;
  verticalSeparatorsVisible: boolean;
};

// Non-interactive visual overlays drawn as <th> children: the pinned top-edge
// strip, the full-height pinned edge line, the active resize indicator, and the
// column separator. The interactive resize handle stays in HeaderCell.
export function HeaderCellDecorators(props: HeaderCellDecoratorsProps) {
  return (
    <>
      {/* Pinned indicator — orange strip at top edge, visible on all pinned columns */}
      <Show when={props.isPinned}>
        <span style={PINNED_INDICATOR_STYLE} />
      </Show>

      {/* Pinned edge line: always-visible separator for pinned columns (column separator is hidden for pinned).
          Elevation shade on the last left-pinned column — the pinned/scrollable boundary. */}
      <Show when={!props.isBeingResized && props.isPinnedLeft}>
        <span
          style={
            props.isLastPinnedLeft ? PINNED_LEFT_BOUNDARY_LINE_STYLE : PINNED_LEFT_EDGE_LINE_STYLE
          }
        />
      </Show>
      <Show when={!props.isBeingResized && props.isRightPinned}>
        <span style={PINNED_RIGHT_EDGE_LINE_STYLE} />
      </Show>
      {/* Resize indicator / separators / drop indicators */}
      {/* Right-pinned columns use a left-side indicator so it aligns with the left-side handle */}
      <Show when={props.isBeingResized}>
        <span style={props.isRightPinned ? RESIZE_INDICATOR_LEFT_STYLE : RESIZE_INDICATOR_STYLE} />
      </Show>
      {/* Column separator: only on non-pinned cells (pinned cells use the edge line above)
          and only when the verticalSeparators grid setting is on, so toggling it actually
          affects both header and body (T20-118961). */}
      <Show when={!props.isBeingResized && !props.isPinned && props.verticalSeparatorsVisible}>
        <span style={COLUMN_SEPARATOR_STYLE} />
      </Show>
    </>
  );
}
